import { Record, List } from 'immutable';
import SearchFilterItemValue, { SearchFilterItemValues } from 'records/SearchFilterItemValues';

const defaultValues = {
  itemType: '',
  itemValue: SearchFilterItemValues(),
  itemKey: '',
}

const initValues = [
  {
    itemType: 'Colors',
    itemKey: 'design.major-color',
  },
  {
    itemType: 'Graphic Category',
    itemKey: 'GRAPHIC',
  },
  {
    itemType: 'Occasion',
    itemKey: 'occasion',
  },
  {
    itemType: 'Cuisine Type',
    itemKey: 'food',
  },
  {
    itemType: 'Type of Business',
    itemKey: 'business',
  },
];

export default class SearchFilter extends Record(defaultValues, SearchFilter) {
  constructor(values) {
    super({
      ...values,
      itemValue: values && values.itemValue
                      ? SearchFilterItemValues(values.itemValue)
                      : defaultValues.itemValue,
    });
  }

  static updateSearchFilterItem(filters, type, value, multiple) {
    return filters.map((item) => {
      if (item.get('itemType') === type) {
        if(multiple) {
          let filterValues = this.getFilterItemValues(item.get('itemValue'), value)
          if(filterValues.size === 0){
            //for adding new search condition
            let newItemValue = new SearchFilterItemValue();
            newItemValue = newItemValue.set('filterValue', value);
            item = item.updateIn(['itemValue'], arr => arr.push(newItemValue));
            return item;
          } else {
            //for removing the checked condition
            let filterIndex = this.finditemFilterIndexByVal(item.get('itemValue'), value);
            item = item.updateIn(['itemValue'], arr => arr.delete(filterIndex));

            return item;
          }
        } else {
          if(value === 'placeholder') {
            item = item.setIn(['itemValue'], new List());
            return item;
          } else {
            let filterValue = new SearchFilterItemValue();
            filterValue = filterValue.set('filterValue', value);
            item = item.setIn(['itemValue', 0], filterValue);
            return item;
          }
        }
      } else {
        return item;
      }
    });
  }

  static finditemFilterIndexByVal(itemValues, val) {
    return itemValues.findIndex(item => {
      return item.get('filterValue') === val ? item : undefined;
    });
  }

  static getFilterItemValues(itemValues, val) {
    return itemValues.filter((item) => {
      return item.get('filterValue') == val;
    });
  }

  static getFilterItems(filters) {
    return filters.filter((item) => {
      return item.get('itemValue') && item.get('itemValue').size !=0;
    });
  }

  static getFilterItemValueByItemType(filters, type) {
    return filters.filter((item) => {
      return item.get('itemType') === type;
    });
  }

  static getOtherFilterItems(filters, type) {
    return filters.filter((item) => {
      return item.get('itemKey') !== type;
    });
  }

  static getItemTypeByItemKey(filters, itemKey) {
    return filters.filter((item) => {
      return item.get('itemKey') === itemKey;
    })
  }

  static filterProductByItemKey(products, itemKey, itemValue) {
    return products.filter((product) => {
      return this.getFilterItemValues(itemValue, product[itemKey]).size > 0;
    });
  }

}

export const SearchFilters = (data) => {
  let searchFilters = new List();
  if(data) {
    data.forEach((value) => {
      searchFilters = searchFilters.push(new SearchFilter(value));
    });
  } else {
    // just for backgroud search filters template
    initValues.forEach((value) => {
      searchFilters = searchFilters.push(new SearchFilter(value));
    });
  }
  return searchFilters;
};
